// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-5-container {
    background-color: #0B63E5;
    color: white;
    margin: auto;
    padding: 3rem;
    margin-bottom: 10rem;
}

.section-5-top {
    width: 80%;
    margin: auto;
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.section-5-line1 {
    font-size: var(--font-size3);
    margin: 0;
    font-weight: lighter;
}

.section-5-line2 {
    font-size: var(--font-size3);
    margin: 0;
    font-weight: bold;
}

.section-5-line3 {
    font-size: var(--font-size8);
    margin: 0;
    width: 50%;
}

.section-5-bottom {
    width: 85%;
    display: flex;
    gap: 1rem;
    margin: auto;
    justify-content: space-between;

    & hr {
        rotate: 90%;
        border: 1.5px solid white;
    }
}

.section-5-bottom>div {
    width: 20%;
}

.section-5-head {
    display: flex;
    font-size: var(--font-size6);
    font-weight: bold;
    align-items: center;
    gap: 1.5rem;

    & img {
        width: 3rem;
        height: 3rem;
    }
}

.section-5-desc {
    width: 80%;
    font-size: var(--font-size4);
    font-weight: lighter;
}

@media screen and (min-width:300px) and (max-width:490px) {

    .section-5-container {
        padding: 2rem 0.5rem;
        margin-bottom: var(--margin-bottom-mobile);
    }

    .section-5-top {
        width: 92%;
    }

    .section-5-line1,
    .section-5-line2 {
        font-size: var(--font-size8);
    }

    .section-5-line3 {
        font-size: 0.75rem;
        width: 90%;
    }

    .section-5-bottom {
        flex-direction: column;
        width: 92%;
        gap: 0.5rem;

        & hr {
            width: 100%;
        }
    }

    .section-5-head {
        font-size: 1rem;

        & img {
            width: 2rem;
            height: 2rem;
        }
    }

    .section-5-desc {
        font-size: 0.75rem;
    }

    .section-5-bottom>div {
        width: 100%;
        display: flex;

        & img:nth-child(2) {
            width: 30%;
        }
    }

    .section-5-bottom>div:nth-child(3),
    .section-5-bottom>div:nth-child(7) {
        flex-direction: row-reverse;
        gap: 2rem;
    }
}

@media screen and (min-width:601px) and (max-width:840px) {
    .section-5-container {
        padding: 2rem 0.5rem;
        margin-bottom: 5rem;
    }

    .section-5-top {
        width: 80%;
    }

    .section-5-line1,
    .section-5-line2 {
        font-size: var(--font-size6);
    }

    .section-5-line3 {
        font-size: 1rem;
        width: 80%;
    }

    .section-5-bottom {
        flex-direction: column;
        width: 80%;
        gap: 0.5rem;

        & hr {
            width: 100%;
        }
    }

    .section-5-bottom-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
    }

    .section-5-head {
        font-size: 1.5rem;

        & img {
            width: 2rem;
            height: 2rem;
        }
    }

    .section-5-desc {
        font-size: 1rem;
    }

    .section-5-bottom>div {
        width: 100%;
        display: flex;

        & img:nth-child(2) {
            width: 20%;
        }
    }

    .section-5-bottom>div:nth-child(3),
    .section-5-bottom>div:nth-child(7) {
        flex-direction: row-reverse;
        gap: 2rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Homepage/Section5.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,4BAA4B;IAC5B,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;IAC5B,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,UAAU;IACV,aAAa;IACb,SAAS;IACT,YAAY;IACZ,8BAA8B;;IAE9B;QACI,WAAW;QACX,yBAAyB;IAC7B;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;;IAEX;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;;IAEI;QACI,oBAAoB;QACpB,0CAA0C;IAC9C;;IAEA;QACI,UAAU;IACd;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,UAAU;QACV,WAAW;;QAEX;YACI,WAAW;QACf;IACJ;;IAEA;QACI,eAAe;;QAEf;YACI,WAAW;YACX,YAAY;QAChB;IACJ;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,aAAa;;QAEb;YACI,UAAU;QACd;IACJ;;IAEA;;QAEI,2BAA2B;QAC3B,SAAS;IACb;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,UAAU;IACd;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;QACI,eAAe;QACf,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,UAAU;QACV,WAAW;;QAEX;YACI,WAAW;QACf;IACJ;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,qBAAqB;IACzB;;IAEA;QACI,iBAAiB;;QAEjB;YACI,WAAW;YACX,YAAY;QAChB;IACJ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;;QAEb;YACI,UAAU;QACd;IACJ;;IAEA;;QAEI,2BAA2B;QAC3B,SAAS;IACb;AACJ","sourcesContent":[".section-5-container {\r\n    background-color: #0B63E5;\r\n    color: white;\r\n    margin: auto;\r\n    padding: 3rem;\r\n    margin-bottom: 10rem;\r\n}\r\n\r\n.section-5-top {\r\n    width: 80%;\r\n    margin: auto;\r\n    margin-bottom: 1rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n}\r\n\r\n.section-5-line1 {\r\n    font-size: var(--font-size3);\r\n    margin: 0;\r\n    font-weight: lighter;\r\n}\r\n\r\n.section-5-line2 {\r\n    font-size: var(--font-size3);\r\n    margin: 0;\r\n    font-weight: bold;\r\n}\r\n\r\n.section-5-line3 {\r\n    font-size: var(--font-size8);\r\n    margin: 0;\r\n    width: 50%;\r\n}\r\n\r\n.section-5-bottom {\r\n    width: 85%;\r\n    display: flex;\r\n    gap: 1rem;\r\n    margin: auto;\r\n    justify-content: space-between;\r\n\r\n    & hr {\r\n        rotate: 90%;\r\n        border: 1.5px solid white;\r\n    }\r\n}\r\n\r\n.section-5-bottom>div {\r\n    width: 20%;\r\n}\r\n\r\n.section-5-head {\r\n    display: flex;\r\n    font-size: var(--font-size6);\r\n    font-weight: bold;\r\n    align-items: center;\r\n    gap: 1.5rem;\r\n\r\n    & img {\r\n        width: 3rem;\r\n        height: 3rem;\r\n    }\r\n}\r\n\r\n.section-5-desc {\r\n    width: 80%;\r\n    font-size: var(--font-size4);\r\n    font-weight: lighter;\r\n}\r\n\r\n@media screen and (min-width:300px) and (max-width:490px) {\r\n\r\n    .section-5-container {\r\n        padding: 2rem 0.5rem;\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n    .section-5-top {\r\n        width: 92%;\r\n    }\r\n\r\n    .section-5-line1,\r\n    .section-5-line2 {\r\n        font-size: var(--font-size8);\r\n    }\r\n\r\n    .section-5-line3 {\r\n        font-size: 0.75rem;\r\n        width: 90%;\r\n    }\r\n\r\n    .section-5-bottom {\r\n        flex-direction: column;\r\n        width: 92%;\r\n        gap: 0.5rem;\r\n\r\n        & hr {\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    .section-5-head {\r\n        font-size: 1rem;\r\n\r\n        & img {\r\n            width: 2rem;\r\n            height: 2rem;\r\n        }\r\n    }\r\n\r\n    .section-5-desc {\r\n        font-size: 0.75rem;\r\n    }\r\n\r\n    .section-5-bottom>div {\r\n        width: 100%;\r\n        display: flex;\r\n\r\n        & img:nth-child(2) {\r\n            width: 30%;\r\n        }\r\n    }\r\n\r\n    .section-5-bottom>div:nth-child(3),\r\n    .section-5-bottom>div:nth-child(7) {\r\n        flex-direction: row-reverse;\r\n        gap: 2rem;\r\n    }\r\n}\r\n\r\n@media screen and (min-width:601px) and (max-width:840px) {\r\n    .section-5-container {\r\n        padding: 2rem 0.5rem;\r\n        margin-bottom: 5rem;\r\n    }\r\n\r\n    .section-5-top {\r\n        width: 80%;\r\n    }\r\n\r\n    .section-5-line1,\r\n    .section-5-line2 {\r\n        font-size: var(--font-size6);\r\n    }\r\n\r\n    .section-5-line3 {\r\n        font-size: 1rem;\r\n        width: 80%;\r\n    }\r\n\r\n    .section-5-bottom {\r\n        flex-direction: column;\r\n        width: 80%;\r\n        gap: 0.5rem;\r\n\r\n        & hr {\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    .section-5-bottom-content {\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        align-content: center;\r\n    }\r\n\r\n    .section-5-head {\r\n        font-size: 1.5rem;\r\n\r\n        & img {\r\n            width: 2rem;\r\n            height: 2rem;\r\n        }\r\n    }\r\n\r\n    .section-5-desc {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .section-5-bottom>div {\r\n        width: 100%;\r\n        display: flex;\r\n\r\n        & img:nth-child(2) {\r\n            width: 20%;\r\n        }\r\n    }\r\n\r\n    .section-5-bottom>div:nth-child(3),\r\n    .section-5-bottom>div:nth-child(7) {\r\n        flex-direction: row-reverse;\r\n        gap: 2rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
